import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {
  showMoveMenu,
  setMoveMenu
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.boxes[ownProps.id-1].type,
    
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
